export const shadowVariants = {
  shadow: {
    '2xs': 'shadow-2xs',
    xs: 'shadow-xs',
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
    xl: 'shadow-xl',
    '2xl': 'shadow-2xl',
    none: 'shadow-none',
  },
  'shadow-sm': {
    '2xs': 'sm:shadow-2xs',
    xs: 'sm:shadow-xs',
    sm: 'sm:shadow-sm',
    md: 'sm:shadow-md',
    lg: 'sm:shadow-lg',
    xl: 'sm:shadow-xl',
    '2xl': 'sm:shadow-2xl',
    none: 'sm:shadow-none',
  },
  'shadow-md': {
    '2xs': 'md:shadow-2xs',
    xs: 'md:shadow-xs',
    sm: 'md:shadow-sm',
    md: 'md:shadow-md',
    lg: 'md:shadow-lg',
    xl: 'md:shadow-xl',
    '2xl': 'md:shadow-2xl',
    none: 'md:shadow-none',
  },
  'shadow-lg': {
    '2xs': 'lg:shadow-2xs',
    xs: 'lg:shadow-xs',
    sm: 'lg:shadow-sm',
    md: 'lg:shadow-md',
    lg: 'lg:shadow-lg',
    xl: 'lg:shadow-xl',
    '2xl': 'lg:shadow-2xl',
    none: 'lg:shadow-none',
  },
  'shadow-xl': {
    '2xs': 'xl:shadow-2xs',
    xs: 'xl:shadow-xs',
    sm: 'xl:shadow-sm',
    md: 'xl:shadow-md',
    lg: 'xl:shadow-lg',
    xl: 'xl:shadow-xl',
    '2xl': 'xl:shadow-2xl',
    none: 'xl:shadow-none',
  },
}
